// CRA no permite require() con ruta variable, asi que las imagenes se importan
// una a una y se exponen por la misma clave que usan article y las traducciones.
// Al anadir un articulo hay que tocar este fichero; a cambio, si falta una
// imagen la build falla en vez de descubrirse en produccion.
import rgsClinicPc from "./rgs_clinic_pc.png";
import rgsClinicOrbbec from "./rgs_clinic_orbbec.png";
import rgsClinicLeapMotion from "./rgs_clinic_leap_motion.png";
import rgsClinicMonitor from "./rgs_clinic_monitor.png";
import rgsClinicAccessories from "./rgs_clinic_accessories.png";
import rgsClinicSetup from "./rgs_clinic_setup.png";
import rgsClinicForearmSupport from "./rgs_clinic_forearm_support.png";
import rgsPlusTablet from "./rgs_plus_tablet.png";
import rgsPlusPhoneHolder from "./rgs_plus_phone_holder.png";

const itemImages = {
  rgs_clinic_pc: rgsClinicPc,
  rgs_clinic_orbbec: rgsClinicOrbbec,
  rgs_clinic_leap_motion: rgsClinicLeapMotion,
  rgs_clinic_monitor: rgsClinicMonitor,
  rgs_clinic_accessories: rgsClinicAccessories,
  rgs_clinic_setup: rgsClinicSetup,
  rgs_clinic_forearm_support: rgsClinicForearmSupport,
  rgs_plus_tablet: rgsPlusTablet,
  rgs_plus_phone_holder: rgsPlusPhoneHolder,
};

export default itemImages;
